<template>
  <div class="ptStarka">
    <menuBox :step="1"></menuBox>
    <div class="ptStarka-box">
      <div class="left">
        <div class="title">Vay dễ dàng, giải ngân nhanh chóng</div>
        <div class="text">VayDễ cung cấp cho người dùng Việt Nam dịch vụ vay tiền trực tuyến tiện lợi, với hạn mức linh
          hoạt, lãi suất minh bạch, hồ sơ đơn giản, xét duyệt nhanh chóng giúp bạn đáp ứng nhu cầu tài chính.
        </div>
      </div>
    </div>
    <div class="movies-box">
      <div class="title">Về chúng tôi</div>
      <div class="text">Phân loại doanh nghiệp APP</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/home1.png" />
          <div class="fire">
            <p>khoản vay cá nhân</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home2.png" />
          <div class="fire">
            <p>Tiêu dùng trả góp</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home3.png" />
          <div class="fire">
            <p>vay tín dụng</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home4.png" />
          <div class="fire">
            <p>khoản vay khẩn cấp</p>
          </div>
        </div>
      </div>
    </div>
    <div class="our-box">
      <div class="left">
        <img src="../assets/home5.png" />
      </div>
      <div class="right">
        <div class="title">Về chúng tôi</div>
        <div class="text">Tại sao chọn VayDễ?</div>
        <div class="bt">VayDễ cung cấp dịch vụ vay tiền trực tuyến với tốc độ xét duyệt nhanh chóng và lựa chọn linh
          hoạt, đơn giản hóa quy trình đăng ký, đảm bảo tính bảo mật, giúp người dùng dễ dàng đáp ứng nhu cầu tài chính
          một cách linh hoạt và tiện lợi.</div>
        <div class="list">
          <img src="../assets/home6.png" />
          <div>
            <p>Phê duyệt nhanh</p>
            <span>VayDễ cung cấp ứng dụng trực tuyến theo thời gian thực và quy trình phê duyệt nhanh chóng, do đó người
              dùng có thể được phê duyệt khoản vay trong thời gian ngắn và giải quyết các nhu cầu tài chính cấp bách của
              mình.</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/home7.png" />
          <div>
            <p>Lựa chọn linh hoạt</p>
            <span>Số tiền vay và thời hạn trả nợ đa dạng cho bạn lựa chọn, hoàn toàn tùy chỉnh theo nhu cầu cá nhân,
              giúp việc vay vốn trở nên linh hoạt và thuận tiện hơn.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="top-box">
      <div class="title">Về chúng tôi</div>
      <div class="text">Dẫn đầu ngành</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/home8.png" />
          <div class="fire">
            <p>Hệ thống kiểm soát rủi ro</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home9.png" />
          <div class="fire">
            <p>Công cụ phê duyệt</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home10.png" />
          <div class="fire">
            <p>Bảo vệ mã hóa</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home11.png" />
          <div class="fire">
            <p>Thuật toán linh hoạt</p>
          </div>
        </div>
      </div>
    </div>
    <div class="live-box">
      <div class="bt">về chúng tôi</div>
      <div class="title">người dùng của chúng tôi</div>
      <div class="text">Kể từ khi ra mắt, VayDễ đã phục vụ thành công hơn 500.000 người dùng Việt Nam trực tuyến/ngoại
        tuyến, giúp họ nhanh chóng nhận được khoản vay cần thiết và nâng cao trải nghiệm dịch vụ tài chính của người
        dùng.</div>
      <div class="active">
        <div class="info">
          <p>2000.000 USD </p>
          <span>50W+ người dùng</span>
        </div>
      </div>
    </div>
    <div class="rated-box">
      <div class="title">Về chúng tôi</div>
      <div class="text">làm việc theo nhóm</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/home13.png" />
          <div class="fire">
            <p>Đội ngũ chuyên nghiệp</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home14.png" />
          <div class="fire">
            <p>đổi mới công nghệ</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home15.png" />
          <div class="fire">
            <p>Hiểu biết sâu sắc về nhu cầu</p>
          </div>
        </div>
        <div class="item">
          <img src="../assets/home16.png" />
          <div class="fire">
            <p>phát triển công nghệ</p>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "aboutUs" });
    }
  },
};
</script>

<style lang="less" scoped>
.ptStarka-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 312px;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  background-image: url(../assets/home.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  box-sizing: border-box;

  .left {
    width: 460px;

    .title {
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 24px;
      color: #E5D806;
      line-height: 33px;
    }

    .text {
      font-weight: 700;
      font-size: 30px;
      color: #FFFFFF;
    }
  }
}

.movies-box {
  padding: 100px 312px;
  background: #1E1D21;
  box-sizing: border-box;

  .title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
  }

  .text {
    margin-bottom: 56px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 45px;
  }

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      margin-right: 32px;

      .home1 {
        width: 300px;
        height: 430px;
      }

      .fire {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        p {
          font-weight: 700;
          font-size: 16px;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          color: #E5D806;
        }
      }

      .hd {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .hd-b {
          padding: 5px 10px;
          border: 2px solid #FFFFFF;
          font-size: 12px;
          color: #E5D806;
        }

        .hd-min {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #FFFFFF;

          .time {
            margin-left: 24px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}

.our-box {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 90px 312px;
  background: #121119;

  .left {
    img {
      margin-right: 96px;
      width: 510px;
      height: 546px;
    }
  }

  .right {
    .title {
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 14px;
      color: #E5D806;
    }

    .text {
      margin-bottom: 24px;
      font-weight: 700;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
    }

    .bt {
      margin-bottom: 80px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 18px;
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 65px;

      img {
        margin-right: 24px;
        width: 93px;
        height: 93px;
      }

      div {
        p {
          margin-bottom: 16px;
          font-weight: 700;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 28px;
        }

        span {
          font-size: 16px;
          color: #FFFFFF;
          line-height: 18px;
        }
      }
    }
  }
}

.top-box {
  padding: 100px 312px;
  background: #1E1D21;

  .title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
    text-align: center;
  }

  .text {
    margin-bottom: 56px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 45px;
    text-align: center;
  }

  .list-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 80px;

    .list {
      padding: 18px 20px;
      margin-right: 18px;
      background: #080B0D;
      border-radius: 8px;
      font-weight: 700;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 19px;
    }

    .list:nth-child(1) {
      color: #E5D806;
      border: 1px solid #E5D806;
    }
  }

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      margin-right: 32px;

      .home1 {
        width: 300px;
        height: 430px;
      }

      .fire {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        p {
          font-weight: 700;
          font-size: 16px;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          color: #E5D806;
        }
      }

      .hd {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .hd-b {
          padding: 5px 10px;
          border: 2px solid #FFFFFF;
          font-size: 12px;
          color: #E5D806;
        }

        .hd-min {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #FFFFFF;

          .time {
            margin-left: 24px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}

.live-box {
  width: 100%;
  padding: 200px 312px;
  background-image: url(../assets/home12.png);
  width: 100%;
  height: 726px;
  background-size: 100% 100%;
  box-sizing: border-box;

  .bt {
    max-width: 650px;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
  }

  .title {
    max-width: 650px;
    margin-bottom: 24px;
    font-size: 32px;
    color: #121119;
    line-height: 45px;
  }

  .text {
    max-width: 650px;
    margin-bottom: 40px;
    font-size: 16px;
    color: #121119;
    line-height: 18px;
  }

  .active {
    display: flex;
    align-items: center;

    .hd {
      margin-right: 20px;
      font-weight: 700;
      font-size: 60px;
      color: #FFFFFF;
      line-height: 85px;
      text-stroke: 1px #D81C2C;
      text-align: left;
      font-style: normal;
      -webkit-text-stroke: 1px #D81C2C;
    }

    .info {
      p {
        font-weight: 700;
        font-size: 32px;
        color: #121119;
        line-height: 45px;
      }

      span {
        font-weight: 700;
        font-size: 14px;
        color: #121119;
        line-height: 19px;
      }
    }
  }
}

.rated-box {
  padding: 100px 312px;
  background: #1E1D21;
  box-sizing: border-box;

  .title {
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #E5D806;
    line-height: 19px;
    text-align: center;
  }

  .text {
    margin-bottom: 56px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 45px;
    text-align: center;
  }

  .itemBox {
    display: flex;

    .item {
      width: 25%;
      margin-right: 32px;

      .home1 {
        width: 300px;
        height: 430px;
      }

      .fire {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        p {
          font-weight: 700;
          font-size: 16px;
          color: #FFFFFF;
        }

        span {
          font-size: 16px;
          color: #E5D806;
        }
      }

      .hd {
        margin-top: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .hd-b {
          padding: 5px 10px;
          border: 2px solid #FFFFFF;
          font-size: 12px;
          color: #E5D806;
        }

        .hd-min {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #FFFFFF;

          .time {
            margin-left: 24px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}
</style>
